export const blockIconsPhotoandimageFilterVintageNew = (
	<span className='material-symbols-outlined'>filter_vintage</span>
);
